// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"f3503bd6","167":"ecb72fe7","408":"c38a6def","706":"a5a8a160","751":"adfbfc80","830":"126bb234","895":"9c7ac414","938":"83fe69b4","941":"e408235c","944":"826f2bc4"}[chunkId] + ".chunk.js";
};